class Common {
    // 4xx系, 5xx系のエラーをさばくハンドラ
    static handleErrors(response) {
        // console.log("commonResponse");
        // console.log(response);
        // 4xx系, 5xx系エラーのときには response.ok==false になる
        // console.log("commonResponse");
        // console.log(response);
        if (response.status === 200) {
            const res = JSON.parse(response.request.response);
            // console.log(res);
            return res;
        } else if(response.status === 401 || response.code === 401 || response.status === 404){
            //認証エラーの際はトークンリフレッシュし、再描画
            console.log('リフレッシュ開始');
            //AzureAD Access トークンリフレッシュ
            fetch(window.location.protocol + '//' + window.location.host
            + '/.auth/refresh'
            , {
                method: 'GET',
                mode: 'cors'
            })
            .then(() => {
                window.alert('ログイン期限が切れました。ログイン期限を更新します。\n画面更新後このメッセージが出た場合、ブラウザを開きなおしてください。');
                //true : ウェブサーバのデータから画面更新
                //false: キャッシュから画面更新
                window.location.reload(true);
                return;
            });
        }else{
            // console.log("ERROR RESPONSE");
            // console.log(response)
        }
    }

    //APIサーバーURLの取得
    static apiServerUrl() {
        let server = '';
        if (process.env.NODE_ENV === 'development') {
            server = process.env.REACT_APP_API_URL;
        }else if (process.env.NODE_ENV === 'production') {
            // server = window.location.origin;
            server = process.env.REACT_APP_API_URL;
        }
        return server;
    }

}

export default Common;
